<template>
  <div>
    <div style="text-align: -webkit-center; margin-bottom: 10px;">
      <vs-alert 
        v-if="firstTruck.status_cam == -1" 
        title="Alerta" 
        color="warning" 
        active
        style="width: 300px;"
      >
        Cámara con error de código
      </vs-alert>
      <vs-alert 
        v-if="firstTruck.status_cam == 0" 
        title="Alerta" 
        color="warning" 
        active
        style="width: 300px;"
      >
        Cámara desconectada
      </vs-alert>
    </div>
    <!-- Fila de información del camión -->
    <div v-if="truck.length > 0 && firstTruck.box" class="truck-row">
      <div class="item">
        <img src="@/assets/images/icons/caex.png" alt="Camión CAEX" />
        <strong> Tipo:</strong> {{ firstTruck.box.type }}
      </div>
      <div class="item">
        <img src="@/assets/images/icons/modelo.png" alt="Modelo CAEX" />
        <strong> Modelo:</strong> {{ firstTruck.box.model }}
      </div>
      <div class="item">
        <img src="@/assets/images/icons/id.png" alt="Id CAEX" />
        <strong> ID:</strong> {{ firstTruck.box.id }}
      </div>
      <div class="item">
        <img src="@/assets/images/icons/estado.png" alt="Estado CAEX" />
        <strong> Estado:</strong> {{ firstTruck.state }}
      </div>
      <div class="item">
        <img src="@/assets/images/icons/conexion.png" alt="Conexion CAEX" />
        <strong> Últ. Conexión:</strong> {{ firstTruck.lastka_time }}
      </div>
    </div>

    <hr size="8px" color="black" />

    <!-- Tabla de acciones -->
    <vs-table :data="truck">
      <template slot="thead">
        <vs-th> Mostrar Alertas </vs-th>
        <vs-th> Mostrar video disponibles para transferir </vs-th>
        <vs-th> Imagen Miniatura </vs-th>
        <vs-th> Geolocalización </vs-th>
        <vs-th> Historial de Cámaras </vs-th>
        <vs-th> Salud Actual </vs-th>
        <vs-th> Historial de Salud </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :state="data[indextr].status == 'online' ? 'success' : data[indextr].status == '' ? 'warning' : data[indextr].status == 'offline' ? 'danger' : null" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td class="ps_button">
            <vs-button @click="toggleSection('alerts')" color="warning" text-color="primary" size="small">
              Abrir Alertas
            </vs-button>
          </vs-td>
          <vs-td class="ps_button">
            <vs-button @click="toggleSection('videos')" color="warning" text-color="primary" size="small">
              Abrir Videos
            </vs-button>
          </vs-td>
          <vs-td>
            <vs-button @click="popupActivo = true" color="primary" type="filled" size="small">
              Abrir Imagen Miniatura
            </vs-button>
          </vs-td>
          <vs-td>
            <vs-button @click="openMapPopup" color="primary" type="filled" size="small">
              Abrir Mapa
            </vs-button>
          </vs-td>
          <vs-td>
            <vs-button @click="toggleSection('cameras')" color="primary" type="filled" size="small">
              Abrir Historial de Cámaras
            </vs-button>
          </vs-td>
          <vs-td>
            <img @click="openHealthModal = true" src="@/assets/images/icons/informacion.png" alt="Ver salud actual" class="icon-button" />
          </vs-td>
          <vs-td>
            <img @click="openHistoryPopup" src="@/assets/images/icons/history-clock.png" alt="Ver historial de salud" class="icon-button" />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <!-- Sección de Alertas -->
    <vs-col v-if="activeSection === 'alerts' && truck.length > 0">
      <vs-card class="cardx">
        <div slot="header"><h4>Alertas</h4></div>
        <div><AlertsProximity :box_id="firstTruck.id" /></div>
      </vs-card>
    </vs-col>
    
    <!-- Sección de Videos -->
    <vs-col v-if="activeSection === 'videos'">
      <vs-col type="flex" vs-justify="center" vs-align="center">
        <vs-card class="cardx">
          <div slot="header">
            <h4>Videos disponibles en el equipo</h4>
          </div>
          <div v-if="truck.length > 0">
            <VideoList :box_id="firstTruck.id" />
          </div>
        </vs-card>
      </vs-col>
    </vs-col>
    
    <!-- Sección de Gráfico Histórico de Cámaras -->
    <vs-col v-if="activeSection === 'cameras' && truck.length > 0">
      <vs-card class="cardx">
        <div slot="header">
          <h4>Historial de Estado de Cámaras</h4>
        </div>
        <div class="charts-container">
            <div class="filters">
                <label>Desde:</label>
                <input type="datetime-local" v-model="cameraDateFilters.start">
                <label>Hasta:</label>
                <input type="datetime-local" v-model="cameraDateFilters.end">
                <vs-button @click="applyCameraDateFilter()" size="small" color="primary">Filtrar</vs-button>
            </div>
            <div class="chart-wrapper">
              <canvas id="cameraStatusChart"></canvas>
            </div>
        </div>
      </vs-card>
    </vs-col>

    <!-- Popups -->
    <vs-popup v-if="truck.length > 0" title="Imagen Detalle" :active.sync="popupActivo" class="dynamic-image-popup">
      <div class="image-popup-wrapper">
        <Thumbnails 
          :img="firstTruck.thumbnail && firstTruck.thumbnail.length > 50 
                ? getThumbnailSrc(firstTruck.thumbnail)
                : require('@/assets/image_not_available.jpg')"
        />
      </div>
    </vs-popup>
    
    <MapModal :show="popupActivo1" @close="popupActivo1 = false" class="responsive-map-modal">
        <!-- Slot para el cuerpo (Contenido principal: Filtros y Mapa) -->
        <template #body>
            <!-- 
                2. Contenedor principal: debe garantizar una altura completa (h-full) para que 
                   flex-grow funcione correctamente en el contenedor del mapa.
            -->
            <div class="h-full w-full flex flex-col">
                
                <!-- Card de Filtros (flex-shrink-0 asegura que no se comprima) -->
                <vs-card v-if="firstTruck.lat != 0" class="cardx mb-3 flex-shrink-0">
                    <!-- <h5 class="mb-2">Filtro de Historial de Tracking (Máx. 1 semana)</h5><small class="text-info block mt-1">Por defecto se muestran las **últimas 20 posiciones**.</small> -->
                    <div class="flex items-center space-x-3 flex-wrap filters-tracking">
                        <label>Desde:</label>
                        <!-- Usamos clases de Tailwind para padding y bordes -->
                        <input type="datetime-local" class="input_of_find p-2 border rounded-md" v-model="trackingFilters.startDateTime"/>
                        
                        <label class="ml-3">Hasta:</label>
                        <input type="datetime-local" class="input_of_find p-2 border rounded-md" v-model="trackingFilters.endDateTime"/>

                        <vs-button class="ml-4 flex-shrink-0" @click="fetchHistory(false)" color="success" type="filled" icon="search">Filtrar</vs-button>
                    </div>
                </vs-card>

                <!-- Contenedor del Mapa -->
                <!-- 
                    3. flex-grow: Ocupa todo el espacio restante.
                    4. min-h-0: Esencial para que el elemento pueda encogerse correctamente en un flexbox.
                    5. Usamos pl-5 en lugar de padding inline.
                -->
                <div class="flex-grow min-h-0"> 
                    <!-- 
                        6. IMPORTANTE: El componente Leaflet debe tener h-full w-full 
                           para que su contenedor (el div padre) le pase la altura calculada 
                           por flex-grow. El mapa se inicializará con esas dimensiones.
                    -->
                    <leaflet 
                        ref="leafletMap"
                        class="h-full w-full"
                        :lat="firstTruck.lat" 
                        :lon="firstTruck.lon" 
                        :history-points="historyPoints"
                        @open-thumbnail="openImageFromHistory"
                    /> 
                </div>

            </div>
        </template>
    </MapModal>

    <vs-popup title="Detalles de Salud del Boxstreamer" :active.sync="openHealthModal">
      <div v-if="firstTruck.performance" class="health-details-container">
        <vs-row class="details-section">
          <vs-col vs-w="4"><strong>Nombre de CAEX:</strong> {{ firstTruck.box_name }}</vs-col>
          <vs-col vs-w="4"><strong>Vehículo:</strong> {{ firstTruck.truck }}</vs-col>
          <vs-col vs-w="4"><strong>Última Conexión:</strong> {{ firstTruck.lastka_time }}</vs-col>
          <vs-col vs-w="4"><strong>Reporte:</strong> {{ firstTruck.lastka_time_report }}</vs-col>
          <vs-col vs-w="4"><strong>IP dBi:</strong> {{ firstTruck.gsm_ip === -1 ? 'No IP' : firstTruck.gsm_ip }}</vs-col>
          <vs-col vs-w="4"><strong>Señal dBi:</strong> {{ firstTruck.gsm_signal }}</vs-col>
          <vs-col vs-w="4"><strong>VPN:</strong> {{ firstTruck.vpn_ip }}</vs-col>
          <vs-col vs-w="4"><strong>Dirección MAC:</strong> {{ firstTruck.mac }}</vs-col>
          <vs-col vs-w="4"><strong>IMEI:</strong> {{ firstTruck.imei }}</vs-col>
          <vs-col vs-w="4"><strong>SSD:</strong> {{ firstTruck.ssd }}%</vs-col>
        </vs-row>
        <vs-divider position="left">Detalles de Rendimiento (Performance)</vs-divider>
        <vs-collapse accordion>
          <vs-collapse-item>
            <div slot="header">Métricas de CPU y Memoria</div>
            <vs-row>
              <vs-col vs-w="6"><strong>CPU1:</strong> {{ firstTruck.performance.CPU1 }}%</vs-col>
              <vs-col vs-w="6"><strong>CPU2:</strong> {{ firstTruck.performance.CPU2 }}%</vs-col>
              <vs-col vs-w="6"><strong>CPU3:</strong> {{ firstTruck.performance.CPU3 }}%</vs-col>
              <vs-col vs-w="6"><strong>CPU4:</strong> {{ firstTruck.performance.CPU4 }}%</vs-col>
              <vs-col vs-w="6"><strong>RAM:</strong> {{ (firstTruck.performance.RAM * 100).toFixed(2) }}%</vs-col>
              <vs-col vs-w="6"><strong>SWAP:</strong> {{ (firstTruck.performance.SWAP * 100).toFixed(2) }}%</vs-col>
            </vs-row>
          </vs-collapse-item>
          <vs-collapse-item>
            <div slot="header">Temperaturas y Energía</div>
            <vs-row>
              <vs-col vs-w="6"><strong>Temp CPU:</strong> {{ firstTruck.performance.Temp_CPU }}°C</vs-col>
              <vs-col vs-w="6"><strong>Temp GPU:</strong> {{ firstTruck.performance.Temp_GPU }}°C</vs-col>
              <vs-col vs-w="6"><strong>Temp AO:</strong> {{ firstTruck.performance.Temp_AO }}°C</vs-col>
              <vs-col vs-w="6"><strong>Temp PLL:</strong> {{ firstTruck.performance.Temp_PLL }}°C</vs-col>
              <vs-col vs-w="6"><strong>Temp Térmica:</strong> {{ firstTruck.performance.Temp_thermal }}°C</vs-col>
              <vs-col vs-w="6"><strong>Consumo Total (TOT):</strong> {{ firstTruck.performance.Power_TOT }}W</vs-col>
            </vs-row>
          </vs-collapse-item>
          <vs-collapse-item>
            <div slot="header">Estado de Procesos y Conexión</div>
            <vs-row>
              <vs-col vs-w="6"><strong>Uptime:</strong> {{ firstTruck.performance.uptime }}</vs-col>
              <vs-col vs-w="6"><strong>APE_MASTER:</strong> {{ firstTruck.performance.APE_MASTER }}</vs-col>
              <vs-col vs-w="6"><strong>GPU:</strong> {{ firstTruck.performance.GPU }}%</vs-col>
              <vs-col vs-w="6"><strong>Jetson Clocks:</strong> {{ firstTruck.performance.jetson_clocks }}</vs-col>
              <vs-col vs-w="6"><strong>Modelo NVP:</strong> {{ firstTruck.performance.nvp_model }}</vs-col>
              <vs-col vs-w="6"><strong>Estado de VIC03:</strong> {{ firstTruck.performance.VIC03 }}</vs-col>
            </vs-row>
          </vs-collapse-item>
        </vs-collapse>
      </div>
    </vs-popup>

    <vs-popup title="Historial de Salud del CAEX" :active.sync="openHistoryModal" ref="historyPopup" @after-close="destroyCharts">
      <div class="popup-content-wrapper">
        <div class="charts-container">
            <div class="filters">
                <label>Desde:</label>
                <input type="datetime-local" v-model="dateFilters.start">
                <label>Hasta:</label>
                <input type="datetime-local" v-model="dateFilters.end">
                <vs-button @click="applyHealthDateFilter" size="small" color="primary">Filtrar</vs-button>
            </div>
            <div class="chart-wrapper"><h4>CPU (%)</h4><canvas id="cpuChart"></canvas></div>
            <div class="chart-wrapper"><h4>RAM (%)</h4><canvas id="ramChart"></canvas></div>
            <div class="chart-wrapper"><h4>Disco SSD (%)</h4><canvas id="ssdChart"></canvas></div>
        </div>
        <div class="popup-resizer" @mousedown="initResize"></div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import VideoList from '../box/VideoList.vue';
import leaflet from "../utils/Map";
import Thumbnails from "../utils/Thumbnails";
import axios from 'axios';
import AlertsProximity from "../box/AlertsProximity.vue";
import Chart from 'chart.js/auto';
import MapModal from "../utils/ModalLeaflet.vue";

export default {
  name: "boxstates",
  props: {
    show_alert: Boolean,
  },
  components: {
    leaflet,
    Thumbnails,
    AlertsProximity,
    VideoList,
    MapModal
  },
  data: () => ({
    popupActivo: false,
    popupActivo1: false,
    truck: [],
    box_id: '',
    showModal: false,
    activeSection: null,
    openHealthModal: false,
    openHistoryModal: false,
    historyPoints: [], // Almacena los puntos del historial (lat, lon, datetime, velocity, gsm_signal, thumbnail_url)
    trackingFilters: { // Filtros de fecha/hora para el tracking
      startDateTime: '', 
      endDateTime: ''    
    },
    historyData: [],
    dateFilters: { start: '', end: '' },
    cameraStatusHistoryData: [],
    cameraDateFilters: { start: '', end: '' },
    cameraSearchPerformed: false,
    chartInstances: {
      cpu: null,
      ram: null,
      ssd: null,
      cameraStatus: null
    },
    resizing: false,
    popupElement: null,
    initialMouseX: 0,
    initialMouseY: 0,
    initialWidth: 0,
    initialHeight: 0
  }),
  computed: {
    firstTruck() {
      return this.truck.length > 0 ? this.truck[0] : {};
    },
  },
  methods: {
    getThumbnailSrc(base64Data) {
      // 1. Verificar si la data Base64 existe y es válida
      if (base64Data && base64Data.length > 0) {
        // 2. Verificar si ya tiene el prefijo (por ejemplo, si fuera una URL completa)
        if (base64Data.startsWith('data:image/')) {
          return base64Data;
        } else {
          // 3. Añadir el prefijo MIME para Base64 (asumiendo formato JPEG)
          return `data:image/jpeg;base64,${base64Data}`;
        }
      } 
      // 4. Devolver la imagen por defecto si no hay Base64 válido
      else {
        // Usar require() para que webpack/bundler procese la imagen de assets
        return require('@/assets/image_not_available.jpg');
      }
    },
    toggleSection(sectionName) {
      if (this.activeSection === sectionName) {
        this.activeSection = null;
      } else {
        this.activeSection = sectionName;
        // === CORRECCIÓN: Si abrimos la sección de cámaras, cargamos sus datos por defecto ===
        if (sectionName === 'cameras') {
          this.$nextTick(() => {
            this.applyCameraDateFilter(true); // El 'true' indica que es la carga inicial.
          });
        }
      }
    },
    getInfoBox() {
      if (this.$route.params.id) {
        localStorage.setItem("box_id", this.$route.params.id);
        this.box_id = this.$route.params.id;
      } else {
        this.box_id = localStorage.getItem("box_id");
      }
      const url_api = this.$store.state.url_api;
      axios.get(url_api + 'api/boxState', { params: { box_id: this.box_id } })
        .then(response => {
          this.truck = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openHistoryPopup() {
      this.openHistoryModal = true;
      this.$nextTick(() => {
        this.popupElement = this.$refs.historyPopup.$el.querySelector('.vs-popup');
        if (this.popupElement) {
          if (!this.popupElement.style.width) this.popupElement.style.width = '800px';
          if (!this.popupElement.style.height) this.popupElement.style.height = '600px';
        }
        this.applyHealthDateFilter(true);
      });
    },
    applyHealthDateFilter(isInitialLoad = false) {
        let { start, end } = this.dateFilters;
        if (isInitialLoad === true) {
            start = null; 
            end = null;
        } else {
            if (!start || !end) {
                alert("Por favor, selecciona una fecha y hora de inicio y fin.");
                return;
            }
            start = start.replace('T', ' ');
            end = end.replace('T', ' ');
        }
        this.fetchHistoryData(start, end);
    },
    applyCameraDateFilter(isInitialLoad = false) {
      this.cameraSearchPerformed = true;
      let startDateStr, endDateStr;

      if (isInitialLoad || (!this.cameraDateFilters.start && !this.cameraDateFilters.end)) {
        // Carga inicial o filtro sin fechas: usa el último día por defecto
        startDateStr = null;
        endDateStr = null;
      } else if (!this.cameraDateFilters.start || !this.cameraDateFilters.end) {
        alert("Por favor, seleccione un rango de fechas completo.");
        return;
      }
      else {
        // El usuario ha filtrado con fechas específicas
        startDateStr = this.cameraDateFilters.start.replace('T', ' ');
        endDateStr = this.cameraDateFilters.end.replace('T', ' ');
      }
      
      this.fetchCameraStatusHistory(startDateStr, endDateStr);
    },
    async fetchCameraStatusHistory(startDate, endDate) {
      const url_api = this.$store.state.url_api;
      const params = { 
        box_id: this.box_id,
        limit: this.$store.state.limit || 200
      };
      if (startDate) params.start_date = startDate;
      if (endDate) params.end_date = endDate;
      try {
        const response = await axios.get(url_api + 'api/boxStatusHistory', { params });
        this.cameraStatusHistoryData = response.data;
      } catch (error) {
        console.error("Error al obtener historial de cámaras:", error);
        this.cameraStatusHistoryData = [];
      } finally {
        this.$nextTick(() => this.renderCameraStatusChart());
      }
    },
    // === Nuevo Método: Abrir Popup de Mapa y Cargar Historial ===
    openMapPopup() {
      this.popupActivo1 = true;
      
      // Solo si hay coordenadas válidas, inicializa la carga del historial
      if (this.firstTruck.lat != 0) {
        this.$nextTick(() => {
          // Establecer el rango por defecto (ej. las últimas 4 horas o 1 día)
          // Para la carga inicial, llamamos a fetchHistory sin filtros, lo que cargará las últimas 20.
          this.fetchHistory(true); 
        });
      }
    },

    // === Nuevo Método: Obtener Historial de Posiciones ===
    async fetchHistory(isInitialLoad = false) {
      const url_api = this.$store.state.url_api;
      const box_id = this.firstTruck.box_id || this.box_id;
      
      if (!box_id) return;

      const params = {
        box_id: box_id,
      };

      if (isInitialLoad || (!this.trackingFilters.startDateTime && !this.trackingFilters.endDateTime)) {
        // Carga por defecto: últimas 20 posiciones
        params.limit = 20;
      } else {
        // Filtro de Rango: enviar fechas al backend
        if (!this.trackingFilters.startDateTime || !this.trackingFilters.endDateTime) {
          this.$vs.notify({ title: 'Error', text: 'Debe seleccionar ambas fechas para filtrar.', color: 'danger' });
          return;
        }
        // El backend debe validar que el rango no exceda 1 semana.
        params.start_date = this.trackingFilters.startDateTime.replace('T', ' ');
        params.end_date = this.trackingFilters.endDateTime.replace('T', ' ');
      }

      try {
          this.$vs.loading();
          // === IMPORTANTE: Usar el nuevo endpoint para el historial ===
          const response = await axios.get(url_api + 'api/caex/history', { params }); 
          this.historyPoints = response.data;
          this.$vs.notify({ title: 'Éxito', text: `Se cargaron ${this.historyPoints.length} posiciones.`, color: 'success' });

      } catch (error) {
          console.error("Error al obtener el historial de posiciones:", error);
          this.historyPoints = [];
          let errorMessage = 'No se pudo cargar el historial. Revise la conexión o el ID de la caja.'; // Mensaje genérico por defecto

          // === LÓGICA CLAVE: Extraer el mensaje específico del servidor ===
          if (error.response && error.response.status === 400 && error.response.data && error.response.data.error) {
              // Mostrar el mensaje de error específico enviado por el servidor Flask (e.g., "El rango de fechas no puede exceder los 2 días...")
              errorMessage = error.response.data.error;
          } else if (error.message) {
              // Para errores de red o tiempo de espera
              errorMessage = error.message;
          }
          
          this.$vs.notify({ 
              title: 'Error de Solicitud', 
              text: errorMessage, 
              color: 'danger', 
              time: 5000 // Aumentar el tiempo para que el usuario pueda leer la validación
          }); 
          
      } finally {
          this.$vs.loading.close();
      }
    },

    // === Método de soporte para abrir la imagen desde el tooltip del mapa ===
    openImageFromHistory(thumbnailUrl) {
      if (thumbnailUrl) {
        // Asumiendo que 'openModal' está en un componente padre o globalmente accesible
        // Si no está, debes crear un nuevo popup para manejar esta imagen. 
        
        // SOLUCIÓN VUE-FRIENDLY: Usamos un evento global o abrimos un nuevo popup temporal
        // Para simplicidad, vamos a usar un evento para mostrar la imagen en un nuevo popup
        
        // Necesitas un nuevo popup en el template y una nueva variable en data() para la URL
        // Como alternativa simple: abrir en una nueva pestaña (menos integrado):
        window.open(thumbnailUrl, '_blank'); 
      } else {
        this.$vs.notify({ title: 'Atención', text: 'No hay evidencia disponible para este punto.', color: 'warning' });
      }
    },
    async fetchHistoryData(startDate, endDate) {
      const url_api = this.$store.state.url_api;
      const params = { box_id: this.box_id };
      if (startDate) params.start_date = startDate;
      if (endDate) params.end_date = endDate;
      try {
        const response = await axios.get(url_api + 'api/boxHistory', { params });
        this.historyData = response.data;
        if (this.openHistoryModal) {
            this.$nextTick(() => this.renderCharts());
        }
      } catch (error) {
        console.error("Error al obtener datos históricos:", error);
      }
    },
    renderCharts() {
      if (!this.openHistoryModal || !this.historyData || this.historyData.length === 0) {
        this.destroyCharts();
        return;
      }
      const createOrUpdateChart = (chartId, chartInstance, datasetConfig) => {
        const ctx = document.getElementById(chartId);
        if(!ctx) return null;
        if (chartInstance) chartInstance.destroy();
        return new Chart(ctx.getContext('2d'), {
          type: 'line',
          data: {
            labels: datasetConfig.labels,
            datasets: [{ 
                label: datasetConfig.label,
                data: datasetConfig.data,
                borderColor: datasetConfig.borderColor,
                fill: false, tension: 0.1, pointRadius: 2 
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: { y: { beginAtZero: true, max: 100 } },
            animation: false
          }
        });
      };
      const labels = this.historyData.map(d => new Date(d.lastka_time).toLocaleString());
      this.chartInstances.cpu = createOrUpdateChart('cpuChart', this.chartInstances.cpu, {
          labels, label: 'Uso de CPU', 
          data: this.historyData.map(d => (d.performance && d.performance.CPU1 != null) ? d.performance.CPU1 : 0), 
          borderColor: '#ef5350'
      });
      this.chartInstances.ram = createOrUpdateChart('ramChart', this.chartInstances.ram, {
          labels, label: 'Uso de RAM', 
          data: this.historyData.map(d => d.performance ? (d.performance.RAM * 100) : 0), 
          borderColor: '#42a5f5'
      });
      this.chartInstances.ssd = createOrUpdateChart('ssdChart', this.chartInstances.ssd, {
          labels, label: 'Uso de Disco SSD', 
          data: this.historyData.map(d => d.ssd), 
          borderColor: '#66bb6a'
      });
    },
    renderCameraStatusChart() {
      if (this.chartInstances.cameraStatus) {
        this.chartInstances.cameraStatus.destroy();
      }
      const ctx = document.getElementById('cameraStatusChart');
      if (!ctx) return;
      
      if (!this.cameraSearchPerformed && this.cameraStatusHistoryData.length === 0) {
        this.chartInstances.cameraStatus = new Chart(ctx.getContext('2d'), {
            type: 'line',
            data: { labels: [], datasets: [] },
            options: { plugins: { title: { display: true, text: 'Utilice los filtros para buscar el historial.' }}}
        });
        return;
      }
      
      if (this.cameraStatusHistoryData.length === 0) {
        this.chartInstances.cameraStatus = new Chart(ctx.getContext('2d'), {
            type: 'line',
            data: { labels: [], datasets: [] },
            options: { plugins: { title: { display: true, text: 'No hay datos disponibles para el rango seleccionado.' }}}
        });
        return;
      }
      
      const labels = this.cameraStatusHistoryData.map(d => new Date(d.datetime).toLocaleString());
      const data = this.cameraStatusHistoryData.map(d => d.status_cam);
      
      this.chartInstances.cameraStatus = new Chart(ctx.getContext('2d'), {
        type: 'line',
        data: {
          labels: labels,
          datasets: [{
            label: 'Estado de Cámaras',
            data: data,
            borderColor: '#ff9800',
            fill: false,
            tension: 0.1,
            pointRadius: 2
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: { y: { beginAtZero: true } },
          animation: false
        }
      });
    },
    destroyCharts() {
      Object.values(this.chartInstances).forEach(chart => {
        if (chart) chart.destroy();
      });
      this.chartInstances = { cpu: null, ram: null, ssd: null, cameraStatus: null };
    },
    initResize(event) {
      this.resizing = true;
      this.popupElement = this.$refs.historyPopup.$el.querySelector('.vs-popup');
      this.initialWidth = this.popupElement.offsetWidth;
      this.initialHeight = this.popupElement.offsetHeight;
      this.initialMouseX = event.clientX;
      this.initialMouseY = event.clientY;
      window.addEventListener('mousemove', this.doResize);
      window.addEventListener('mouseup', this.stopResize);
    },
    doResize(event) {
      if (this.resizing) {
        const dx = event.clientX - this.initialMouseX;
        const dy = event.clientY - this.initialMouseY;
        this.popupElement.style.width = `${this.initialWidth + dx}px`;
        this.popupElement.style.height = `${this.initialHeight + dy}px`;
        this.handlePopupResize();
      }
    },
    stopResize() {
      this.resizing = false;
      window.removeEventListener('mousemove', this.doResize);
      window.removeEventListener('mouseup', this.stopResize);
    },
    handlePopupResize() {
        if (this.chartInstances.cpu) this.chartInstances.cpu.resize();
        if (this.chartInstances.ram) this.chartInstances.ram.resize();
        if (this.chartInstances.ssd) this.chartInstances.ssd.resize();
    }
  },
  mounted() {
    this.getInfoBox();
  },
  beforeDestroy() {
    this.destroyCharts();
    window.removeEventListener('mousemove', this.doResize);
    window.removeEventListener('mouseup', this.stopResize);
  }
};
</script>
<style>
.ps_images {
  padding: 15px;
}
.ps_button {
  margin-left: 10px;
}
.card-title {
  margin-top: 20px;
}
.ps_select_live {
  float: left;
}
.ps_show_live {
  float: left;
  margin: 3px;
}
.ps_div_icon .vs-icon {
  vertical-align: bottom !important;
}
.bg-alert-proximity {
  background: rgb(236, 236, 236);
}
.truck-row {
  background-color: #f2f2f2;
  border-radius: 18px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 24px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  font-family: 'Segoe UI', sans-serif;
  color: #333;
  font-size: 18px;
  overflow-x: auto;
}
.item {
  margin: 0 12px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #fff;
  padding: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  margin-right: 8px; /* Espacio entre icono y texto */
}
.icon-button {
  width: 50px;
  height: 50px;
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.1s ease;
}
.icon-button:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
.icon-button:active {
  transform: scale(0.95);
}
.health-details-container {
  padding: 20px;
}
.details-section {
  display: flex;
  flex-wrap: wrap;
}
.details-section .vs-col {
  padding: 8px 15px;
}

/* --- ESTILOS PARA POPUP DE HISTORIAL Y REDIMENSIONAR (BLOQUE FINAL) --- */

/* 1. Controlamos el contenedor interno de Vuesax */
.vs-popup--content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 95%;
}

/* 2. Nuestro wrapper ahora es un hijo flex que crece */
.popup-content-wrapper {
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 3. El contenedor de los gráficos se ajusta y tiene scroll */
.charts-container {
  padding: 20px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;
}

.filters {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.filters label {
  font-weight: bold;
}
.filters input[type="datetime-local"] {
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #ccc;
}
.chart-wrapper {
  position: relative;
  min-height: 180px;
  margin-bottom: 20px;
  flex-shrink: 0;
}
.chart-wrapper canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* 4. Estilos para el popup en general y el agarrador */
.vs-popup {
  transition: none !important;
  min-width: 900px;
  min-height: 800px;
}
.popup-resizer {
  position: absolute;
  right: 1px;
  bottom: 1px;
  width: 15px;
  height: 15px;
  cursor: nwse-resize;
  background: repeating-linear-gradient(-45deg, #b0b0b0, #b0b0b0 1px, transparent 1px, transparent 4px);
  border-top: 1px solid #ddd;
  border-left: 1px solid #ddd;
  opacity: 0.7;
  z-index: 99999;
  margin-top: 5px;
}
/* --- ESTILOS PARA POPUP DE IMAGEN (BLOQUE FINAL) --- */

/* 1. Controla el ancho del vs-popup SOLO para el de la imagen */
.dynamic-image-popup .vs-popup {
  /* Forzamos al popup a ajustarse exactamente al contenido */
  width: fit-content !important; 
  /* Podemos establecer un ancho fijo mínimo si el fit-content falla */
  min-width: 250px;
  min-height: 250px;
}

/* 2. Controla el contenedor intermedio dentro del popup */
.image-popup-wrapper {
  /* Define el tamaño del contenedor al que debe ajustarse Thumbnails */
  width: 200px; /* Ancho fijo deseado */
  height: 200px; /* Alto fijo deseado */
  
  /* Centra el componente Thumbnails dentro de este wrapper */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px; /* Padding interno */
}

/* 3. Asegúrate de que el contenido de Vuesax (que contiene el wrapper) no limite el tamaño */
.dynamic-image-popup .vs-popup--content {
  /* Esto es para evitar conflictos con la configuración de otros popups */
  overflow: hidden;
  padding: 0;
  align-items: center;
}
/* --- ESTILOS PARA POPUP DE GEOLOCALIZACIÓN --- */

/* 1. Hacer que el popup se ajuste al contenido (la clave de la flexibilidad) */
.geolocation-popup .vs-popup {
  width: fit-content !important; 
  /* El mapa y la imagen deben tener un tamaño consistente */
  min-width: 400px;
  min-height: 250px;
}

/* 2. Definir el tamaño del contenedor principal (600x400) para AMBOS escenarios */
.geolocation-popup .leaflet-map-wrapper {
  width: 1000px; /* Ancho deseado para el mapa y la imagen de error */
  height: 650px; /* Alto deseado para el mapa y la imagen de error */
  padding: 10px; /* Espacio alrededor */
  
  /* Centrado si el contenido hijo (como Thumbnails) es más pequeño */
  display: flex; 
  justify-content: center;
  align-items: center;
}


/* 3. Asegurar que el componente Thumbnails dentro del wrapper se ajuste */
/* Esto va en tu bloque de estilos del componente padre, si no puedes modificar Thumbnails */
/* Si ya modificaste Thumbnails para que sea flexible (width: 100%, object-fit: contain), no es necesario. */
.geolocation-popup .leaflet-map-wrapper .thumbnail-container {
  /* Aquí forzamos que el Thumbnail ocupe el 100% o el 50% del espacio, según tu gusto */
  width: 50%; /* Por ejemplo, para que la imagen no disponible no se estire demasiado */
  height: 50%;
}
/* ... dentro del bloque <style> existente ... */

/* Estilos para el contenedor de filtros del historial de tracking */
.filters-tracking {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 10px;
}
.filters-tracking label {
    font-weight: 500;
}
.filters-tracking input[type="datetime-local"] {
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #ccc;
}
/* Asegura que el contenedor de mapa sea visible con los filtros */
/* Estilos conceptuales para MapModal */
.responsive-map-modal .vs-popup--content {
    /* Establece la altura y anchura relativa para que el modal escale con el viewport */
    width: 90vw !important;
    height: 90vh !important;
    max-width: 90vw !important; 
    max-height: 90vh !important;
    
    /* Aseguramos un tamaño mínimo pequeño para que pueda reducirse al alejar el zoom */
    min-width: 300px !important;
    min-height: 300px !important;

    /* Asegúrate de que el contenido del modal pueda scrollear si es necesario */
    overflow: hidden; 
}

/* Asegura que el contenedor del contenido sea h-full */
.responsive-map-modal .vs-popup--content > div { 
    height: 100%;
}
</style>
